import React from "react";
import Switch from "react-switch";

function SiteSwitch(props) {
    return <Switch {...props}/>
}

export default SiteSwitch;